<template>
    <div class="template-base">
        <Header Title="CardPointe Compare" :iconPath="'/images/icons/compare.png'" class="div-header"></Header>
        <div class="menu-bar">
            <Button class="x-smaller-button" :buttonModel="btnExit"></Button>

            <Button style="border: 3px solid" for="fileUpload" class="x-smaller-button" :buttonModel="btnImport" @on-clicked="selectFile" :disabled="fetchingData" :disable="fetchingData" />
            <input ref="refFileUpload" type="file" id="fileUpload" style="display: none;" @change="handleFile" />

            <!-- Header-->
            <div style="display:flex; height: 50px;"></div>
        </div>

        <div style="margin:10px">
            CardPointe export file must included the default fields plus MID, Order Id, and Front End.
            <br/> 
            Make sure to set the correct time zone in CardPointe before when exporting data</div>        
            <div style="margin:10px;" v-if="model.merchantId.length > 0">File: {{ model.fileName }}</div>            
            
            <hr style="width: 100%;" v-if="model.merchantId.length > 0"/>

            <div style="margin:10px;">Send to facility if CardPointe is updated to Portal: <span style="background-color: green;color:white"> {{ Utilities.toCurrency(model.portalNetTotal) }}</span></div>
            <br/>

            <div style="margin:10px;font-weight: bold;" v-if="model.merchantId.length > 0">Overview</div>
            <div style="background: white; overflow-y: auto;height: 6%;width:99%;text-align: center;margin: 0 auto" v-if="model.merchantId.length > 0">
                <table class="report-div-table" cellspacing="0">
                    <tr class="report-div-table-row">
                        <th class="report-div-table-col" style="width: 20%">Merchant</th>
                        <th class="report-div-table-col" style="width: 6%">Merchant Id</th>
                        <th class="report-div-table-col" style="width: 9%;">Start Date</th>
                        <th class="report-div-table-col" style="width: 9%">End Date</th>
                        <th class="report-div-table-col" style="width: 9%;text-align:right">CardPointe Total</th>
                        <th class="report-div-table-col" style="width: 9%;text-align:right">Portal Total</th>
                        <th class="report-div-table-col" style="width: 9%;text-align:right;">Diff Total</th>

                        <th class="report-div-table-col" style="width: 9%;text-align:right">CardPointe Count</th>                        
                        <th class="report-div-table-col" style="width: 9%;text-align:right">Portal Count</th>                        
                        <th class="report-div-table-col" style="width: 9%;text-align:right">Diff Count</th>
                    </tr>

                    <tr class="report-div-table-row" style="background-color: transparent;">
                        <td class="report-div-table-col">{{ model.location }}</td>
                        <td class="report-div-table-col">{{ model.merchantId }}</td>
                        <td class="report-div-table-col">{{ model.minDate }}</td>
                        <td class="report-div-table-col">{{ model.maxDate }}</td>

                        <td class="report-div-table-col" style="text-align:right">{{ Utilities.toCurrency(model.cardPointTotalSum) }}</td>
                        <td class="report-div-table-col" style="text-align:right">{{ Utilities.toCurrency(model.incomeLogTotalSum) }}</td>
                        <td class="report-div-table-col" style="text-align:right;background-color: orange;color:black;">{{ Utilities.toCurrency(model.cardPointTotalSum - model.incomeLogTotalSum) }}</td>

                        <td class="report-div-table-col" style="text-align:right">{{ Utilities.toNumeric(model.cardPointTotalCount) }}</td>                        
                        <td class="report-div-table-col" style="text-align:right">{{ Utilities.toNumeric(model.incomeLogTotalCount) }}</td>                        
                        <td class="report-div-table-col" style="text-align:right">{{ Utilities.toNumeric(model.cardPointTotalCount - model.incomeLogTotalCount) }}</td>
                    </tr>
                </table>
            </div>        
                

            <div v-show="model.diffTotalSumByDate.length > 0" style="margin:10px;font-weight: bold">Dates that do not match</div>
            <div v-show="model.diffTotalSumByDate.length > 0" style="background: white; overflow-y: auto;height: 16%;width:25%;">
                <table class="report-div-table" cellspacing="0">
                    <tr class="report-div-table-row">
                        <th class="report-div-table-col" style="width: 20%">Date</th>
                        <th class="report-div-table-col" style="width: 20%">CardPointe</th>                        
                        <th class="report-div-table-col" style="width: 20%">Portal</th>
                        <th class="report-div-table-col" style="width: 20%">Diff</th>                        
                    </tr>

                    <tr v-for="row in model.diffTotalSumByDate" :key="row.date" class="report-div-table-row">
                        <td class="report-div-table-col">{{ row.date }}</td>
                        <td class="report-div-table-col" style="text-align:right">{{ Utilities.toCurrency(row.cardPointe) }}</td>
                        <td class="report-div-table-col" style="text-align:right">{{ Utilities.toCurrency(row.portal) }}</td>
                        <td class="report-div-table-col" style="text-align:right">{{ Utilities.toCurrency(row.cardPointe - row.portal) }}</td>
                    </tr>
                    <tr class="report-div-table-row">
                        <td class="report-div-table-col" colspan="3" style="font-weight: bold;">Total</td>                        
                        <td class="report-div-table-col" style="text-align:right;background-color: orange;color:black;">{{ Utilities.toCurrency(model.diffTotalSumByDateTotal) }}</td>
                    </tr>
                    
                </table>
            </div>


            <div v-show="model.portalMissingTransactions.length > 0" style="margin:10px;font-weight: bold">CardPointe transactions not found in Portal</div>
            <div v-show="model.portalMissingTransactions.length > 0" style="background: white; overflow-y: auto;height: 50%;width:99%;text-align: center;margin: 0 auto">
                <table class="report-div-table" cellspacing="0">
                    <tr class="report-div-table-row">
                        <th class="report-div-table-col" style="width: 8%">Date Time</th>
                        <th class="report-div-table-col" style="width: 3%">Transaction #</th>                        
                        <th class="report-div-table-col" style="width: 2%">Method</th>
                        <th class="report-div-table-col" style="width: 5%">Status</th>
                        <th class="report-div-table-col" style="width: 5%">Portal Status</th>
                        <th class="report-div-table-col" style="width: 2%;text-align:right">Last 4</th>
                        <th class="report-div-table-col" style="width: 5%;">Brand</th>
                        <th class="report-div-table-col" style="width: 4%;">Name</th>
                        <th class="report-div-table-col" style="width: 3%;">Auth Code</th>
                        <th class="report-div-table-col" style="width: 9%;">Order Id</th>                        
                        <th class="report-div-table-col" style="width: 2%;text-align:right">Amount</th>
                    </tr>

                    <tr v-for="row in model.portalMissingTransactions" :key="row.id" class="report-div-table-row">
                        <td class="report-div-table-col">{{ row["Date"] }}</td>
                        <td class="report-div-table-col">{{ row["Transaction #"] }}</td>                        
                        <td class="report-div-table-col">{{ row["Method"] }}</td>
                        <td class="report-div-table-col">{{ row["Status"] }}</td>
                        <td class="report-div-table-col">{{ row.portalStatus }}</td>
                        <td class="report-div-table-col" style="text-align:right">{{ row["Last 4"] }}</td>
                        <td class="report-div-table-col">{{ row["Brand"] }}</td>
                        <td class="report-div-table-col">{{ row["Name"] }}</td>
                        <td class="report-div-table-col">{{ row["Auth Code"] }}</td>
                        <td class="report-div-table-col">{{ row["Order ID"] }}</td>
                        <td class="report-div-table-col" style="text-align:right">{{ row["Amount"] }}</td>
                    </tr>
                    <tr class="report-div-table-row">
                        <td class="report-div-table-col" colspan="10" style="font-weight: bold;">Total</td>                        
                        <td class="report-div-table-col" style="text-align:right;background-color: orange;color:black;">{{ Utilities.toCurrency(model.diffTotalSum) }}</td>
                    </tr>
                    
                </table>
            </div>
                      
    </div>
</template>

<script>
import Header from "@/views/components/Shared/Header";
import Button from "@/views/components/Shared/Button";
import ButtonModel from "@/common/models/ButtonModel";
import { ref } from "vue";
import { getCurrentInstance, onMounted } from "@vue/runtime-core";
import Helper from "@/common/helper";
import CardPointeCompare from "@/common/CardPointeCompare";
import Utilities from "@/common/utilities";

export default {
    components: { Header, Button },
    setup() {
        const emitter = getCurrentInstance().appContext.app.config.globalProperties.emitter;
        const fetchingData = ref(false);

        const uploadType = ref("");
        const refFileUpload = ref(null);
        const model = ref(new CardPointeCompare());

        const btnExit = ButtonModel.CreateRoute("", "Home");
        btnExit.iconPath = "/images/icons/exit.png";
        btnExit.title = "Back to Main Page";

        const btnImport = ButtonModel.CreateClick("");
        btnImport.iconPath = "/images/icons/import-csv.png";
        btnImport.title = "Process CardPointe File...";

        onMounted(() => {
            console.log("Mounted");
        });

        const selectFile = async () => {
            refFileUpload.value.click();
        };

        const handleFile = async () => {
            try {
                const file = event.target.files[0];
                emitter.emit("server-call-start", "Processing data...");
                fetchingData.value = true;

                model.value = new CardPointeCompare();
                await model.value.process(file);
            } catch (err) {
                console.log("ERROR:", err);
                emitter.emit("show-alert", ["Error processing data", err]);
            }
            emitter.emit("server-call-stop");
            fetchingData.value = false;
        };


        return {
            btnExit,
            Helper,
            fetchingData,
            uploadType,
            btnImport,
            refFileUpload,
            selectFile,
            handleFile,
            model,
            Utilities,          
        };
    }
};
</script>

<style scoped>
.cardpointe-compare-input-container {
    display: flex;
    /* justify-content: space-between; */
    margin: 10px;
    padding-left: 10px;
}

.cardpointe-compare-name {
    width: 150px;
}

.cardpointe-compare-input-item {
    width: 250px;
}
</style>
